import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { AccessEntities } from "../AccessEntities";
import PermissionPoliciesRolesTables from "../components/PermissionPoliciesRolesTables";

interface IncomingAccessViewProps extends NSARouterMakerResult, AccessProps { }

function IncomingPermissionViewPage(props: IncomingAccessViewProps)
{
	return (
		<AccessLayout
			{...props}
			action={{
				title: "",
				description: "View the specifics of a permission you've been granted.",
			}}
			pages={{
				entity: AccessEntities.incomingPermission(props),
				ui: {
					action: {
						menus: {
							view_history: false,
						}
					}
				},
				view: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
						getChildrenAfter: (id) => id
							? <PermissionPoliciesRolesTables
								{...props}
								id={id}
								get={props.servers.access.permission.GetIncoming}
							/>
							: <></>
					}
				},
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default IncomingPermissionViewPage;